import React, { PropTypes } from 'react';
import ContentBuilder from '../../Page';




class Fakta extends React.Component {
  constructor(props) {
    super(props);
    this.onClickExpand = this.onClickExpand.bind(this);
    this.onClickFold = this.onClickFold.bind(this);
    this.state = {
      isExpanded: Boolean(props.expanded)
    };
  }


  onClickExpand() {
    this.setState((prevState) => ({
      isExpanded: true
    }));
  }

  onClickFold() {
    this.setState((prevState) => ({
      isExpanded: false
    }));
  }


  render() {
    const { value: { content }} = this.props;
    let style = Object.assign({}, this.props.value.style);
    const { isExpanded } = this.state;
    const styles = require('./styles.scss');
    let classes = styles.mod_default;
    if (isExpanded) {
      style.height = 'auto';
    } else {
      // style = this.props.style || {};
      classes += ` ${styles.folded}`;
    }
    return (
      <div className={classes} style={style} onClick={!isExpanded && this.onClickExpand}>
        <ContentBuilder className="content" data={content} />
        <a className={styles.button} onClick={isExpanded && this.onClickFold}>
          <span className={styles.buttonText}>{isExpanded ? 'Dölj' : 'Visa'}</span>
          <span className={styles.buttonArrow}>
            <span className={styles.buttonArrowLeft}/>
            <span className={styles.buttonArrowRight}/>
          </span>
        </a>
      </div>
    );
  }
}


Fakta.propTypes = {
  content: PropTypes.array,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  expanded: PropTypes.string
};

export default Fakta;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Fakta/Fakta.js
 **/